var render = function render() {
  var _vm = this,
    _c = _vm._self._c,
    _setup = _vm._self._setupProxy
  return _c(
    "div",
    [
      _c("div", { staticClass: "row mb-2" }, [
        _c(
          "div",
          { staticClass: "col-sm-6" },
          [
            _c("search", {
              ref: "search",
              attrs: { suggestions: _vm.suggestions },
              on: { search: _vm.onSearch }
            })
          ],
          1
        ),
        _vm._v(" "),
        _c(
          "div",
          {
            staticClass:
              "col-sm-4 d-flex flex-row justify-content-between align-items-center"
          },
          [
            _c("date-range-picker", {
              staticClass: "mr-1",
              attrs: {
                "locale-data": _vm.dateRangePickerLocale,
                "time-picker": false,
                timePicker24Hour: true,
                showWeekNumbers: true,
                showDropdowns: true,
                autoApply: true,
                ranges: false
              },
              on: { update: _vm.onDateRangeUpdate },
              scopedSlots: _vm._u([
                {
                  key: "input",
                  fn: function(picker) {
                    return [
                      _vm._v(
                        "\n                    " +
                          _vm._s(
                            picker.startDate
                              ? _vm.formatDate(picker.startDate)
                              : _vm.$t("generalAlways")
                          ) +
                          " -\n                    " +
                          _vm._s(
                            picker.endDate
                              ? _vm.formatDate(picker.endDate)
                              : _vm.$t("generalAlways")
                          ) +
                          "\n                "
                      )
                    ]
                  }
                }
              ]),
              model: {
                value: _vm.dateRange,
                callback: function($$v) {
                  _vm.dateRange = $$v
                },
                expression: "dateRange"
              }
            }),
            _vm._v(" "),
            _c(
              "button",
              {
                staticClass: "btn btn-outline-secondary mr-2",
                staticStyle: { "vertical-align": "top" },
                on: {
                  click: function($event) {
                    _vm.dateRange = { endDate: null, startDate: null }
                    _vm.onDateRangeUpdate()
                  }
                }
              },
              [_c("i", { staticClass: "fa fa-dumpster" })]
            ),
            _vm._v(" "),
            _c(
              "div",
              {
                staticClass:
                  "ms-2 d-inline-flex align-items-center border rounded px-2 bg-white",
                staticStyle: { height: "38px" }
              },
              [
                _c("i", { staticClass: "fas fa-filter text-muted small me-2" }),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-check form-check-inline mb-0 me-2" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.statusFilter,
                          expression: "statusFilter"
                        }
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        type: "radio",
                        name: "status",
                        id: _vm._uid + "all",
                        value: "all"
                      },
                      domProps: { checked: _vm._q(_vm.statusFilter, "all") },
                      on: {
                        change: [
                          function($event) {
                            _vm.statusFilter = "all"
                          },
                          _vm.onFilterChanged
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label small",
                        attrs: { for: _vm._uid + "all" }
                      },
                      [_vm._v(_vm._s(_vm.$t("txtAll")))]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-check form-check-inline mb-0 mx-2" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.statusFilter,
                          expression: "statusFilter"
                        }
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        type: "radio",
                        name: "status",
                        id: _vm._uid + "open",
                        value: "open"
                      },
                      domProps: { checked: _vm._q(_vm.statusFilter, "open") },
                      on: {
                        change: [
                          function($event) {
                            _vm.statusFilter = "open"
                          },
                          _vm.onFilterChanged
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label small",
                        attrs: { for: _vm._uid + "open" }
                      },
                      [_vm._v(_vm._s(_vm.$t("txtOpen")))]
                    )
                  ]
                ),
                _vm._v(" "),
                _c(
                  "div",
                  { staticClass: "form-check form-check-inline mb-0 mx-2" },
                  [
                    _c("input", {
                      directives: [
                        {
                          name: "model",
                          rawName: "v-model",
                          value: _vm.statusFilter,
                          expression: "statusFilter"
                        }
                      ],
                      staticClass: "form-check-input",
                      attrs: {
                        type: "radio",
                        name: "status",
                        id: _vm._uid + "done",
                        value: "done"
                      },
                      domProps: { checked: _vm._q(_vm.statusFilter, "done") },
                      on: {
                        change: [
                          function($event) {
                            _vm.statusFilter = "done"
                          },
                          _vm.onFilterChanged
                        ]
                      }
                    }),
                    _vm._v(" "),
                    _c(
                      "label",
                      {
                        staticClass: "form-check-label small",
                        attrs: { for: _vm._uid + "done" }
                      },
                      [_vm._v(_vm._s(_vm.$t("txtDone")))]
                    )
                  ]
                )
              ]
            )
          ],
          1
        ),
        _vm._v(" "),
        _c("div", { staticClass: "col-sm-2" }, [
          _c(
            "button",
            {
              staticClass: "btn btn-primary btn-labeled float-right",
              on: {
                click: function($event) {
                  return _vm.$refs.printModal.open(_vm.moreparams)
                }
              }
            },
            [
              _c("i", { staticClass: "fas fa-file-download" }),
              _vm._v(" " + _vm._s(_vm.$t("txtLogPrint")) + "\n            ")
            ]
          )
        ])
      ]),
      _vm._v(" "),
      _c("vuetable", {
        ref: "vuetable",
        attrs: {
          "api-url": "api/audit/activitieslog",
          "data-path": "data",
          "pagination-path": "",
          "append-params": _vm.moreparams,
          fields: _vm.fields,
          transform: _vm.transformToOpenApi,
          "first-page": 0,
          initialPage: 0,
          "per-page": 10
        },
        on: { "vuetable:pagination-data": _vm.onPaginationData },
        scopedSlots: _vm._u([
          {
            key: "actions",
            fn: function(props) {
              return _c("div", {}, [
                _c(
                  "button",
                  {
                    staticClass: "btn btn-primary btn-sm",
                    on: {
                      click: function($event) {
                        return _vm.onActionClicked(props.rowData)
                      }
                    }
                  },
                  [_c("i", { staticClass: "fas fa-eye" })]
                )
              ])
            }
          }
        ])
      }),
      _vm._v(" "),
      _c("vuetable-pagination", {
        ref: "pagination",
        attrs: { "first-page": 0, css: _vm.mycss.pagination },
        on: { "vuetable-pagination:change-page": _vm.onChangePage }
      }),
      _vm._v(" "),
      _c("vuetable-pagination-info", {
        ref: "paginationinfo",
        attrs: {
          "first-page": 0,
          css: _vm.mycss.pagination,
          infoTemplate: _vm.$t("vuetablePaginationInfoTemplate"),
          noDataTemplate: _vm.$t("vuetablePaginationNoDataTemplate")
        }
      }),
      _vm._v(" "),
      _c("activity-log-modal", {
        ref: "activityLogInfoModal",
        attrs: {
          modalId: "activityLogInfoModal",
          availablePriorities: _vm.availablePriorities,
          duty: _vm.duty,
          activity: _vm.activity,
          cells: _vm.cells
        }
      }),
      _vm._v(" "),
      _c("PrintModal", { ref: "printModal" })
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }